import React, { useState, useEffect } from 'react';

import { Dropdown, FormInput_text, FormInput_textarea, formInput_funcUtility, FormGroupRadio, Toaster } from "components";

import { func_validation, func_currency } from "functions";



export function useBusinessInfo(props) {
    // Props
    const {
        isFormSubmissionAttempted
    } = props;
    
    // States
    const [personInCharge, setPersonInCharge] = useState("");
    const [brand, setBrand] = useState("");
    const [type, setType] = useState("");

    // Display
    let display = (
        <div className="distributorPortal-clientRegistration-businessInfo d-flex">

            {/* Person in Charge */}
            <FormInput_text  
                inputLabel={"Person in Charge"}

                className={"distributorPortal-clientRegistration-personInCharge"}
                inputValue_default={personInCharge} 

                isInputBlurHandlingRequired
                handleInputBlurExtend={(value) => { setPersonInCharge(value); }}

                customErrorMsgDefault={"Required"}
                isFormSubmissionAttempted={isFormSubmissionAttempted}

                isInputValueTrim_onChange
                isMarginBtmOptional
            />

            {/* Brand */}
            <Dropdown
                className={"distributorPortal-clientRegistration-brand"}
                label={"Brand"}

                selectedValueClassName={"distributorPortal-clientRegistration-brand-input"}

                options={[]}
                selectedValue_default={brand}
                onChange={setBrand}

                isFormSubmissionAttempted={isFormSubmissionAttempted} 

                isSearchable
                isInputValueTrim_onChange
            />

            {/* Type */}
            <Dropdown
                className={"distributorPortal-clientRegistration-type"}
                label={"Type"}

                selectedValueClassName={"distributorPortal-clientRegistration-type-input"}

                options={[]}
                selectedValue_default={type}
                onChange={setType}

                isFormSubmissionAttempted={isFormSubmissionAttempted} 

                isSearchable
                isInputValueTrim_onChange
            />

        </div>
    )

    return {
        personInCharge,
        brand,
        type,
        
        display
    }
}